import { Component, OnInit, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'mm-paged-table-column',
  templateUrl: './paged-table-column.component.html',
  styleUrls: ['./paged-table-column.component.scss']
})
export class PagedTableColumnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }
  @Input()
  name: string;

  @Input()
  header: string;

  @Input()
  mmType: string;

  @Input()
  cell: string | TemplateRef<any>

  
  @Input()
  headerCell: string | TemplateRef<any>



}
